module.exports = __webpack_public_path__ + "static/media/A1-11-Kal-Belzeruk-cod93.2412333f.png";